<div class="infigoContain">
    <div class="detail">
        <div class="list">
            <infigo-list [formatNumInaccurate]="formatNumInaccurate"
                [formatNum]="formatNum"
                [noResultTip]="noResultTip"
                [skeletonTemplateRef]="skeletonTemplate"
                [title]="i18n.get('home.Home_network_resources_lab')"
            ></infigo-list>
        </div>
        <div class="detail-block">
            <infigo-detail></infigo-detail>
        </div>
    </div>
    <div class="right">
        <div>
            <infigo-base-list
                [formatNum]="formatNum"
                [noResultTip]="noResultTip"
                [title]="i18n.get('home.search_term_pages_lab')"
                icon="#infigo-page"
                providerType="Page">
            </infigo-base-list>
        </div>
        <div>
            <infigo-base-list
                [formatNum]="formatNum"
                [noResultTip]="noResultTip"
                [title]="i18n.get('home.search_term_operations_lab')"
                icon="#infigo-operation"
                providerType='Operation'>
            </infigo-base-list>
        </div>
        <div>
            <infigo-base-list
                [formatNum]="formatNum"
                [noResultTip]="noResultTip"
                [title]="i18n.get('home.search_term_Help_lab')"
                icon="#infigo-help"
                providerType='Help'>
            </infigo-base-list>
        </div>
    </div>
</div>
<ng-template #skeletonTemplate>
    <div style="margin-bottom: 1px;">
        <app-skeleton [height]="'47px'" [loading]="true"></app-skeleton>
    </div>
</ng-template>

